/**
 * FrontDesk Design System - Layout Components
 *
 * Structured layout components for consistent UI architecture
 */

export * from './ThreeColumnLayout';